
<div v-if="marunage_count > 0" class="ui olive message">
  <ul class="list">
    <li>
      <a href="/shopadmin/candidates?status=false">立候補可能な宴会や会議が{{ marunage_count }}件あります</a>
    </li>
  </ul>
</div>
